export default __webpack_public_path__ + "static/media/emptyList_icon.12948837.svg";